var pic1 = require('../../assets/images/facility/music/pic1.jpg');
var pic2 = require('../../assets/images/facility/music/pic2.jpg');
var pic3 = require('../../assets/images/facility/music/pic3.jpg');
var pic4 = require('../../assets/images/facility/music/pic4.jpg');
var pic5 = require('../../assets/images/facility/music/pic2.jpg');
const DataGalleryFacilityMusicDance = [
 {    
	id: 1,
	title:"music",
    image: pic1,	    
	alt  :"music",
  },
  {    
	id: 2,
	title:"music",
    image: pic2,	    
	alt: "music",
  },
  {    
	id: 3,
	title:"music",
    image: pic3,	    
	alt: "music",
  },
  {    
	id: 4,
	title:"music",
    image: pic4,	    
	alt: "music",
  },
  {    
	id: 5,
	title:"music",
    image: pic5,	    
	alt: "music",
  },
];
export default DataGalleryFacilityMusicDance;